import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import {
  GET_ALL_PROMOTIONS,
  CREATE_PROMOTION,
  UPDATE_PROMOTION,
  DELETE_PROMOTION,
} from "./actionTypes"
import {
  getAllPromotionsCall,
  createPromotionCall,
  updatePromotionCall,
  deletePromotionCall,
  API_URL,
} from "../../helpers/repository"
import { getAllPromotions, getAllPromotionsResponseSuccess } from "./actions"
import { showErrorMessages } from "helpers/helpers"
import { showMessage } from "components/Common/Toaster"
import { apiError } from "store/actions"

function* attemptGetAllPromotions() {
  try {
    const response = yield call(getAllPromotionsCall)
    yield put(getAllPromotionsResponseSuccess(response.data.data))
  } catch (error) {
    showErrorMessages(error)
  }
}

function* attemptCreatePromotion(action) {
  const { history } = action
  try {
    const response = yield call(createPromotionCall, action.payload)
    showMessage("success", response.data.message)
    history.push("/crm/marketing")
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

// -------------------------------------------------------EDIT------------------------------------------------------
function* attemptEditPromotion(action) {
  const { history, id } = action
  try {
    const response = yield call(updatePromotionCall, action.payload, id)
    showMessage("success", response.data.message)
    yield put(getAllPromotions())
    history.push(`/crm/marketing`)
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

// -------------------------------------------------------DELETE------------------------------------------------------
function* attemptDeletePromotion(action) {
  try {
    const response = yield call(deletePromotionCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllPromotions())
  } catch (error) {
    showErrorMessages(error)
  }
}

function* PromotionsSaga() {
  yield takeEvery(GET_ALL_PROMOTIONS, attemptGetAllPromotions)
  yield takeEvery(CREATE_PROMOTION, attemptCreatePromotion)
  yield takeEvery(UPDATE_PROMOTION, attemptEditPromotion)
  yield takeEvery(DELETE_PROMOTION, attemptDeletePromotion)
}

export default PromotionsSaga
